interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  light?: boolean;
}
export function SectionHeading({
  eyebrow,
  title,
  description,
  light = false
}: SectionHeadingProps) {
  return <div className="mx-auto mb-8 max-w-3xl text-center sm:mb-10" data-id="element-165" data-mp="3f1vnlllt2lh3">
      {eyebrow && <p className="mb-3 font-heading text-xs font-extrabold uppercase tracking-[0.18em] text-brandgreen sm:text-sm" data-id="element-166" data-mp="3jzx2rvg420na">{eyebrow}</p>}
      <h2 className={`font-heading text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-5xl ${light ? 'text-white' : 'text-navy'}`} data-id="element-167" data-mp="blerlkuvi4zg">{title}</h2>
      {description && <p className={`mx-auto mt-4 max-w-2xl text-base leading-7 sm:text-lg ${light ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-168" data-mp="1v3o1zf3pxt3">{description}</p>}
    </div>;
}